<style src="./UserMap.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="user-map">
    <ul class="grid-list-container">
      <li class="grid-list-header">
        <ul>
          <li class="col-9">Nome</li>
          <li class="col-1 center"></li>
          <li class="col-1 center"></li>
          <li class="col-1 center"></li>
        </ul>
      </li>

      <li class="grid-list-item" v-for="item, itemIdx in listData" :key="itemIdx">
        <ul>
          <li class="col-11">{{ item.username }}</li>
          <li class="col-1 center">
            <button class="column-button" @click="edit(itemIdx)">
              <icon-edit />
            </button>
          </li>
          <!-- <li class="col-1 center">
            <button class="column-button" @click="edit(itemIdx)">
              <icon-lock />
            </button>
          </li> -->
          <li class="col-1 center">
            <button-remove @remove="removeItem(itemIdx)"/>
          </li>
        </ul>
      </li>
    </ul>
  </section>
</template>

<script>
import { ButtonRemove } from '@/components/primitives'
import { IconEdit, IconLock } from '@/components/primitives/icons'
import { RemoveUser } from '@/brain/record/user'

export default {
  name: 'UserMap',
  components: {
    ButtonRemove,
    IconEdit,
    IconLock
  },
  props: {
    listData: {
      default: []
    }
  },
  data () {
    return {}
  },
  mounted () {},
  methods: {
    edit (pId) {
      this.$emit('edit', pId)
    },
    removeItem (pId) {
      RemoveUser({ _id: this.listData[pId]._id })
        .then((listIdx) => {
          this.$emit('refresh-list')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/user/components/user-map/UserMap.vue